import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Scroll-reveal wrapper — pronounced entrance with smooth deceleration
export function Reveal({ children, as = "div", y = 48, delay = 0, className = "", once = true, ...rest }) {
    const rm = useReducedMotion();
    const M = motion[as] || motion.div;
    return (
        <M
            className={className}
            initial={rm ? { opacity: 0 } : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-8% 0px -8% 0px" }}
            transition={{ duration: 0.85, delay, ease: EASE }}
            {...rest}
        >
            {children}
        </M>
    );
}

// Word-by-word headline reveal with stronger stagger
export function Words({ text, className = "", wordClassName = "", delay = 0, y = "115%", mount = false }) {
    const rm = useReducedMotion();
    const words = String(text).split(" ");
    if (rm) return <span className={className}>{text}</span>;
    const container = {
        hidden: {},
        show: { transition: { staggerChildren: 0.09, delayChildren: delay } },
    };
    const child = {
        hidden: { y },
        show: { y: 0, transition: { duration: 0.95, ease: EASE } },
    };
    const trigger = mount
        ? { animate: "show" }
        : { whileInView: "show", viewport: { once: true, amount: 0.2 } };
    return (
        <motion.span className={className} aria-label={text} variants={container} initial="hidden" {...trigger}>
            {words.map((w, i) => (
                <span key={i} className="inline-block overflow-hidden align-bottom" style={{ paddingBottom: "0.06em" }}>
                    <motion.span className={"inline-block " + wordClassName} variants={child}>
                        {w}
                        {i < words.length - 1 ? "\u00A0" : ""}
                    </motion.span>
                </span>
            ))}
        </motion.span>
    );
}

export const stagger = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12 } },
};
export const fadeUp = {
    hidden: { opacity: 0, y: 44 },
    show: { opacity: 1, y: 0, transition: { duration: 0.85, ease: EASE } },
};
